/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SddcProvidersEnum = 'VMC' | 'GCVE' | 'EVS';

export const SddcProvidersEnum = {

    VMC: 'VMC' as SddcProvidersEnum,

    GCVE: 'GCVE' as SddcProvidersEnum,

    EVS: 'EVS' as SddcProvidersEnum
};

